import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requirePermission } from '@/lib/guards';

/**
 * Layout route for /engagement/resources/:id/*. Renders <Outlet /> so child
 * routes (`/` index = detail screen, `/edit` = edit form) appear here.
 *
 * If this returned the detail screen directly, the edit child would have
 * nowhere to render and clicking "Edit" would silently fail (the URL
 * changes to /edit, but the detail screen continues to render because no
 * Outlet is provided for the matched child route). Mirrors the same
 * layout/index split used in `practitioners/$practitionerId.tsx`.
 */
export const Route = createFileRoute('/_staff/admin/workspace/engagement/resources/$id')({
  beforeLoad: () => {
    requirePermission('engagement:read');
  },
  component: WorkspaceEngagementResourceLayout,
  staticData: { crumb: 'Resource' },
});

function WorkspaceEngagementResourceLayout() {
  return <Outlet />;
}
